export enum ModuleTypes {
  USER_SESSION = 'userSession',
  IDLE_SESSION = 'idleSession',
  STARTUP_SESSION = 'startUpSession',
}
